import { GlobalProctorUI } from "../src/GlobalProctorUI";

export interface ProctorAppPageProps {}
export const ProctorAppPage = (props: ProctorAppPageProps) => {
	return <GlobalProctorUI />;
};
export default ProctorAppPage;
